import React from "react";
import { Redirect } from "react-router-dom";
import { branch, compose, renderComponent, setPropTypes } from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { logout, fetchUserInfo } from "./actions";
import PropTypes from "prop-types";
import { createHocBase } from "app/utils";
import { AppToaster } from "app/toaster";
import { Intent } from "@blueprintjs/core";
import { injectIntl } from "react-intl";

const showToast = message => {
  AppToaster.show({
    intent: Intent.WARNING,
    message,
    iconName: "warning-sign"
  });
};

export const withAuth = compose(
  connect(
    state => {
      return {
        auth: state.auth
      };
    },
    dispatch => ({
      logout: () => dispatch(logout())
    })
  )
);

export const LoginRedirect = props => {
  const urlSearch = window.location.search;
  return (
    <Redirect
      to={{
        pathname: "/login",
        search: urlSearch,
        state: {
          from: props.location,
          showWarning: true
        }
      }}
    />
  );
};

export const withRedirect = compose(
  injectIntl,
  withAuth,
  branch(props => {
    const {
      auth: { isAuthenticated = false, user },
      checkAuth = false,
      logout,
      intl
    } = props;
    if (isAuthenticated) {
      // Check if the JWT token has expired and logout the user
      let now = new Date();
      let exp = new Date(user.exp * 1000);
      if (exp < now) {
        showToast(
          intl.formatMessage({
            id: "auth.session.expired",
            defaultMessage: "Your session has expired. Please log in again"
          })
        );
        logout();
      } else {
        return false;
      }
    }
    return checkAuth;
    // return checkAuth && !isAuthenticated;
  }, renderComponent(LoginRedirect))
);

const selectUserState = (state, props) => {
  return {
    user: state.auth.users[props.userId]
  };
};

const createUserActions = dispatch =>
  bindActionCreators({ fetchUserInfo }, dispatch);

const fetchConditional = props => {
  const { user, fetchUserInfo, userId } = props;
  if (userId && !user) {
    fetchUserInfo({ userId });
  }
};

export const fetchUser = Component =>
  class extends createHocBase(Component) {
    componentDidMount(prevProps) {
      fetchConditional(this.props);
    }
    componentDidUpdate(prevProps) {
      if (this.props.userId === prevProps.userId) return;
      fetchConditional(this.props);
    }
  };

export const connectUserState = connect(selectUserState);

export const connectUserActions = connect(
  null,
  createUserActions
);

export const withUserInfo = compose(
  setPropTypes({
    userId: PropTypes.string.isRequired
  }),
  connectUserState,
  connectUserActions,
  fetchUser
);



// WEBPACK FOOTER //
// ./src/app/auth/hocs.js